import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f46424"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "model-con" }
const _hoisted_2 = { class: "model-title" }
const _hoisted_3 = { class: "expand-btn-con" }
const _hoisted_4 = { class: "model-form-item-con" }
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between","flex-wrap":"wrap"} }
const _hoisted_6 = { class: "publish-input-con" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "publist-tip" }, " 由于试题试卷资源的特殊性，发布后可设置一段时间保密期再公开，默认6个月，可自行修改 ", -1))

import { cloneDeep } from 'lodash';
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue';
import { ref, reactive, onMounted, withDefaults, watch, computed } from 'vue';
import dayjs from 'dayjs';
type SelectItem = {
    categoryCode: string;
    categoryName: string;
    id: string;
    optionList: {
        id: string;
        optionCode: string;
        optionName: string;
    }[];
    parentTags: string;
    subCategoryList: SelectItem[];
};
type PropsType = {
    categoryCode: string;
    categoryName: string;
    tenant: string;
    brand: string;
    options: SelectItem[];
};
type IChooseCategoryOptionList = {
    categoryCode: string;
    optionCode: string;
    optionName: string;
};
type IEmitResult = {
    firstCategoryCode: string;
    chooseCategoryOptionList: IChooseCategoryOptionList[];
    visibleTime?: number;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentFormItem',
  props: {
    categoryCode: { default: undefined },
    categoryName: { default: '' },
    tenant: null,
    brand: null,
    options: { default: () => [] }
  },
  setup(__props: any, { expose }) {

const props = __props as { categoryCode: string, categoryName: string, tenant: string, brand: string, options: SelectItem[] };


expose({ getFormData });

const expand = ref(true);
const formRef = ref();
const formData = reactive({ visibleTime: new Date().getTime() });
const rules = reactive({
    all_stage: [{ required: true, message: '请选择学段' }],
    // delayOpenTimeDuration: [
    //     {
    //         required: false,
    //         validator: (rule, value, callback) => {
    //             if (value >= 0 && value <= 12) {
    //                 return Promise.resolve();
    //             } else {
    //                 return Promise.reject('试题试卷公开时间不可超出0-12个月');
    //             }
    //         }
    //     }
    // ]
});
const shortcuts = [
    {
        text: '今天',
        value: new Date(),
    },
    {
        text: '三个月后',
        value: () => {
            const date = new Date();
            let futherDate: any = dayjs().add(3, 'month');
            date.setTime(futherDate);
            return date;
        },
    },
    {
        text: '六个月后',
        value: () => {
            const date = new Date();
            let futherDate: any = dayjs().add(6, 'month');
            date.setTime(futherDate);
            return date;
        },
    },
    {
        text: '一年后',
        value: () => {
            const date = new Date();
            let futherDate: any = dayjs().add(1, 'year');
            date.setTime(futherDate);
            return date;
        },
    },
];
const visibleTimeRef: any = ref(null);
function disabledDate(date) {
    return date && date.valueOf() < Date.now() - 3600 * 1000 * 24;
}
function visibleTimeFocus() {
    // console.log(visibleTimeRef.value[0], '日期选择器');
    visibleTimeRef.value && visibleTimeRef.value[0].handleOpen();
}
// 用來存储真实的多级select数据
let storeOptions: SelectItem[] = [];
// 降维后的select
const formItemList = ref<SelectItem[]>([]);

// 广度优先的方式对select数据进行扁平化
const getFormatForm = (list: SelectItem[]) => {
    const res: SelectItem[] = [];
    const stash: SelectItem[][] = [];
    const formatter = (list: SelectItem[]) => {
        for (let item of list) {
            if (item.subCategoryList) {
                stash.push(item.subCategoryList);
            }
            const param: any = { ...item };
            delete param.subCategoryList;
            res.push(param);
        }
        const firstOfStash = stash.shift();
        firstOfStash && formatter(firstOfStash);
    };
    formatter(list);
    return res;
};

watch(
    () => props.options,
    () => {
        for (let item of props.options) {
            formData[item.categoryCode] = undefined;
        }
        // 存储options,并将options进行扁平化
        storeOptions = cloneDeep(props.options);
        formItemList.value = getFormatForm(storeOptions);
    },
    { immediate: true },
);

// 变更时查询下一集并更新表单
const handleChange = async (val, selectProps) => {
    const res = await G_transmit('getFilterCommunityAssetCategory', {
        name: 'getFilterCommunityAssetCategory',
        queries: {
            firstCategoryId: selectProps.topTagId || selectProps.parentTags,
            subCategoryId: selectProps.id,
            optionId: val,
            tenant: props.tenant,
            brand: props.brand,
        },
    });
    const activeItem = findActiveItem(storeOptions, selectProps.id);
    if (activeItem) {
        activeItem.subCategoryList = res.data.map(subItem => ({
            ...subItem,
            topTagId: selectProps.topTagId || selectProps.parentTags,
        }));
    }
    formItemList.value = getFormatForm(storeOptions);
};

// 获取最终表单结果
async function getFormData() {
    await formRef.value.validate();
    const chooseCategoryOptionList: IChooseCategoryOptionList[] = [];
    for (let item of formItemList.value) {
        if (formData[item.categoryCode]) {
            const activeOption = item.optionList.find(
                option => option.id === formData[item.categoryCode],
            );
            chooseCategoryOptionList.push({
                categoryCode: item.categoryCode,
                optionCode: activeOption?.optionCode || '',
                optionName: activeOption?.optionName || '',
            });
        }
    }
    const result: IEmitResult = {
        firstCategoryCode: props.categoryCode,
        chooseCategoryOptionList,
    };
    if (props.categoryCode === 'zyzx_stsj') {
        result.visibleTime = formData.visibleTime;
    }
    return result;
}

// 查询改变的select的原始数据
const findActiveItem = (list, val): SelectItem => {
    let res: any;
    const findMethod = list => {
        for (let i = 0; i < list.length; i++) {
            if (list[i].id === val) {
                res = list[i];
                return;
            } else {
                if (list[i].subCategoryList) {
                    findMethod(list[i].subCategoryList);
                }
            }
        }
    };
    findMethod(list);
    return res;
};

const handleClear = item => {
    console.log('item', item);
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "model-title-con",
      onClick: _cache[0] || (_cache[0] = () => (expand.value = !expand.value))
    }, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.categoryName), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(expand.value ? '收起' : '展开'), 1),
        (expand.value)
          ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowUp))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowDown))
              ]),
              _: 1
            }))
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData,
        "label-width": "80px",
        rules: rules,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItemList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_form_item, {
                key: item.categoryCode,
                label: item.categoryName,
                prop: item.categoryCode
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData[item.categoryCode],
                    "onUpdate:modelValue": ($event: any) => ((formData[item.categoryCode]) = $event),
                    placeholder: `点击选择${item.categoryName}`,
                    teleported: false,
                    clearable: item.categoryCode !== 'all_stage',
                    "popper-class": "srt-select-popper",
                    class: _normalizeClass([
                                'form-item-select',
                                'srt-select',
                                {
                                    'srt-clear-select':
                                        item.categoryCode !== 'all_stage' &&
                                        formData[item.categoryCode],
                                },
                            ]),
                    onChange: val => handleChange(val, item),
                    onClear: ($event: any) => (handleClear(item))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.optionList, (opt) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: opt.id,
                          value: opt.id,
                          label: opt.optionName
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "clearable", "class", "onChange", "onClear"])
                ]),
                _: 2
              }, 1032, ["label", "prop"]))
            }), 128)),
            (__props.categoryCode === 'zyzx_stsj')
              ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "公开时间",
                      prop: "visibleTime",
                      class: "entire-line-item",
                      "inline-message": true
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_el_date_picker, {
                            ref_key: "visibleTimeRef",
                            ref: visibleTimeRef,
                            modelValue: formData.visibleTime,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.visibleTime) = $event)),
                            type: "datetime",
                            placeholder: "请选择公开时间",
                            shortcuts: shortcuts,
                            "disabled-date": disabledDate,
                            format: "YYYY-MM-DD HH:mm",
                            onFocus: visibleTimeFocus
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ], 512), [
      [_vShow, expand.value]
    ])
  ], 512)), [
    [_vShow, props.options && props.options.length]
  ])
}
}

})